import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Table } from "../../../helpers";
import { fetchBuyerRateContract } from '../../../services/redux/reducers/buyerRateContract/buyerRateContract';

import { getFullName } from '../../../utils';


const BuyerRateContractTable = (props) => {
    const { onClickEditRateContract } = props

    const userDetails = useSelector((state) => state.userDetails)

    const buyerRateContractData = useSelector(state => state.buyerRateContract.buyerRateContractData);
    const isPageLoading = useSelector(state => state.buyerRateContract.loading);
    const paginationParams = useSelector(state => state.buyerRateContract.paginationParams);
    const searchParams = useSelector(state => state.buyerRateContract.searchParams);
    const pmCompanyUsers = useSelector((state) => state.userDetails.PMCompanyDetails.companyUsers)
    
    const dispatch = useDispatch();

    const branchBody = (row) => {
        if(row.branchId === 0){
            return "ALL"
        }else{
            if(row.companyBranches && row.companyBranches.length > 0){
                return row.companyBranches[0]?.branchName
            }
        }
    }

    const companyERPCodeBody = (row) => {
        if(row.companyERPCodeMap){
            return row.companyERPCodeMap?.companyERPCode
        }
    }

    const companyMaterialIdBody = (row) => {
        if(row.companyERPCodeMap){
            return row.companyERPCodeMap?.materialId
        }
    }

    const companyProdNameBody = (row) => {
        if(row.companyERPCodeMap){
            return row.companyERPCodeMap?.companyProdName
        }
    }

    const companyProdSpecBody = (row) => {
        if(row.companyERPCodeMap){
            return row.companyERPCodeMap?.companyProdSpec
        }
    }

    const companyGSTRateBody = (row) => {
        if(row.companyERPCodeMap){
            return row.companyERPCodeMap?.companyGSTOverride
        }
    }

    const companyERPUnitBody = (row) => {
        if(row.companyERPCodeMap){
            return row.companyERPCodeMap?.companyERPUOM
        }
    }

    const getCompanyERPQtyMultiple = (row) => {
        if(row.companyERPCodeMap){
            return row.companyERPCodeMap.companyQtyMultiplier
        }
    }

    const companyERPCategoryBody = (row) => {
        if(row.companyERPCodeMap){
            return row.companyERPCodeMap?.companyERPCategory
        }
    }

    const companyHSNBody = (row) => {
        if(row.companyERPCodeMap){
            return row.companyERPCodeMap?.companyHSNOverride
        }
    }

    const companyUNSPSCBody = (row) => {
        if(row.companyERPCodeMap){
            return row.companyERPCodeMap?.UNSPSC
        }
    }

    const getRCUpdatedByBody = (row) => {
        const relatedUpdatedByUser = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === row.updatedBy)
        if(!relatedUpdatedByUser){
            return <>-</>
        }
        return (
            <div>{getFullName(relatedUpdatedByUser.firstName, relatedUpdatedByUser.lastName)}</div>
        )
    }

    const verifiedBody = (row) => {
        if(row.verified){
            return (
                <span style={{ color: '#13A89D', fontWeight: 'bold' }}>
                    True
                </span>
            ) 
        }else if(row.verified === false){
            return (
                <span style={{ color: '#F1592A', fontWeight: 'bold' }}>
                    False
                </span>
            )
        }else{
            return "-"
        }
    }

    const verifiedByBody = (row) => {
        if(row.verifiedBy){
            const verifiedUser = pmCompanyUsers.find(eachUser => eachUser.userId === row.verifiedBy)
            if(verifiedUser){
                return getFullName(verifiedUser.firstName, verifiedUser.lastName)
            }
        }
        return "-"
    }

    const editBuyerRateContractBody = (row) => {
        return <i className="pi pi-file-edit" onClick={() => onClickEditRateContract(row)} style={{fontSize: "20px", cursor: "pointer"}}></i>
    }

    const columns = [
        {
            header: 'Branch Name',
            field: 'branchId',
            style: { minWidth: '100px' },
            body: branchBody
        },
        {
            header: 'ERPCode',
            field: 'companyERPCode',
            style: { minWidth: '100px' },
            body: companyERPCodeBody
        },
        {
            header: 'Material Id',
            field: 'materialId',
            style: { minWidth: '100px' },
            body: companyMaterialIdBody
        },
        {
            header: 'Product Name',
            field: 'companyProdName',
            style: { minWidth: '100px' },
            body: companyProdNameBody
        },
        {
            header: 'Specifications',
            field: 'companyProdSpec',
            style: { minWidth: '200px' },
            body: companyProdSpecBody
        },
        {
            header: 'Unit Price',
            field: 'unitPrice',
            style: { maxWidth: '200px' }
        },
        {
            header: 'GSTRate',
            field: 'companyGSTOverride',
            style: { minWidth: '50px' },
            body: companyGSTRateBody
        },
        {
            header: 'ERPUnit',
            field: 'companyERPUOM',
            style: { maxWidth: '200px' },
            body: companyERPUnitBody
        },
        {
            header: 'Qty Multiplier',
            field: 'companyQtyMultiplier',
            style: { maxWidth: '200px' },
            body: getCompanyERPQtyMultiple
        },
        {
            header: 'ERPCategory',
            field: 'companyERPCategory',
            style: { maxWidth: '200px' },
            body: companyERPCategoryBody
        },
        {
            header: 'HSN',
            field: 'companyHSNOverride',
            style: { maxWidth: '200px' },
            body: companyHSNBody
        },
        {
            header: 'UNSPSC',
            field: 'UNSPSC',
            style: { maxWidth: '200px' },
            body: companyUNSPSCBody
        },
        {
            header: 'LeadTime',
            field: 'leadTime',
            style: { maxWidth: '200px' }
        },
        {
            header: 'Validity Period',
            field: 'validityPeriod',
            style: { minWidth: '100px' },
        },
        {
            header: 'Make',
            field: 'make',
            style: { maxWidth: '200px' }
        },
        {
            header: 'Part No.',
            field: 'partNo',
            style: { maxWidth: '200px' }
        },
        {
            header: 'Added By',
            field: '',
            style: { maxWidth: '200px' },
            body: getRCUpdatedByBody
        },
        {
            header: 'Verified',
            field: 'verified',
            body: verifiedBody
        },
        {
            header: 'Verified By',
            field: 'verifiedBy',
            style: { minWidth: '100px' },
            body: verifiedByBody
        },
        {
            header: 'Edit',
            field: 'Edit',
            style: { minWidth: '50px' },
            body: editBuyerRateContractBody
        }
    ];

    const handlePageChange = async (e) => {
        let paginatorParams = {
            ...searchParams,
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: true
        }
        if (searchParams.searchBy && searchParams.searchBy !== "all") {
            paginatorParams[searchParams.searchBy] = searchParams.searchText.trim()
        }
        dispatch(fetchBuyerRateContract(paginatorParams))
    }

    return (
        <Table
            lazy
            page={paginationParams.pageNo}
            onPageChange={(e) => handlePageChange(e)}
            totalRecords={paginationParams.totalRecords}
            tableColumns={columns}
            data={buyerRateContractData}
            rows={paginationParams.recordsPerPage}
            scrollable={"true"}
            scrollHeight="450px"
            paginator
            excessPagesFound={paginationParams.excessPagesFound}
            loading={isPageLoading}

        />
    );
};

export default BuyerRateContractTable;
